import React, {useState} from 'react';
import Container from 'react-bootstrap/Container';
import { Colors, Spacing, Typography } from '_styles';
import { CustomSpinner } from '_atoms';
import Row from 'react-bootstrap/Row';

const Screen = (props) => {
    return (
        <div style={{ backgroundColor:Colors.BACKGROUND_COLOR, width:'100%'}}> 
            <Container style={{opacity: props.loading ? 0.3 : 1.0 }}>
                {props.children}
            </Container>
            {
                props.loading ?
                    <Row style={{position:'absolute', top:'50%', marginLeft:'40%'}}>
                        <CustomSpinner />
                    </Row>
                :
                    null
            }
        </div>
    );
};

export default Screen;